import React, { useReducer } from 'react'
import AuctionContext from './customContext'
import AuctionReducer from './customReducer'
import { apiCall } from '@/product//common/api'
import { response } from '@/product//context/common'
import {
    GET_ALL_SEARCH,
    GET_ALL_PAST_SEARCH,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_DASHBOARD,
    GET_EMD_LIST,
    GET_USER_AGREEMENT,
} from './customTypes'

const AuctionState = (props) => {
    const initialState = {
        search_allauctions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        search_all_pastauction: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        all_user_agreement: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            from: '',
        },
        auction_emd_list: {
            records: [],

            from: '',
        },
        search_alldashboardauctions: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(AuctionReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllAuctionProducts = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'search', formData, '', 'front/auction', true),
            ])
            const from = 'search'
            if (res.data.status === 'success') {
                if (fromVariable === 'pastauction') {
                    dispatch({
                        type: GET_ALL_PAST_SEARCH,
                        payload: {
                            records: res.data.data.responseData.records.length
                                ? res.data.data.responseData.records
                                : [],
                            totalRecords: res.data.data.responseData.totalRecords,
                            setDisp: res.data.data.responseData.setDisp,
                            from: fromVariable,
                        },
                    })
                } else {
                    dispatch({
                        type: GET_ALL_SEARCH,
                        payload: {
                            records: res.data.data.responseData.records.length
                                ? res.data.data.responseData.records
                                : [],
                            totalRecords: res.data.data.responseData.totalRecords,
                            setDisp: res.data.data.responseData.setDisp,
                            from: fromVariable,
                        },
                    })
                }
            } else if (res.data.status === 'error') {
                dispatch({
                    type: RESPONSE_STATUS,
                    payload: {
                        status: res.data.status,
                        message: res.data.data.message,
                        type: res.data.data.responseType,
                        from: from,
                    },
                })
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const addWatchlistauction = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'addAuctionWatchList', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, 'auctionwatchlist')
        } catch (err) {
            resp.commonErrorResponse('auctionwatchlist')
        }
    }
    const userProofDetails = async (fromData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'userProofDetails', fromData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'userProofDetails')
        } catch (err) {
            resp.commonErrorResponse('userProofDetails')
        }
    }

    const userAgreement = async (fromData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'userAgreement', fromData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'userAgreement')
        } catch (err) {
            resp.commonErrorResponse('userAgreement')
        }
    }

    const getUserAgreement = async (formData, fromValue) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getUserAgreement', formData, '', 'user'),
            ])

            if (res.data.status === 'success') {
                dispatch({
                    type: GET_USER_AGREEMENT,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: fromValue,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const userBankDetails = async (fromData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'userBankDetails', fromData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'userBankDetails')
        } catch (err) {
            resp.commonErrorResponse('userBankDetails')
        }
    }

    const userTaxDetails = async (fromData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'userTaxDetails', fromData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'userTaxDetails')
        } catch (err) {
            resp.commonErrorResponse('userTaxDetails')
        }
    }

    const userBrandLocations = async (fromData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'userBrandLocations', fromData, '', 'user'),
            ])
            resp.commonResponse(res.data, 'userBrandLocations')
        } catch (err) {
            resp.commonErrorResponse('userBrandLocations')
        }
    }

    const auctionAccessRequest = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'auctionAccessRequest', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, fromVariable || 'auctionAccessRequest')
        } catch (err) {
            resp.commonErrorResponse(fromVariable || 'auctionAccessRequest')
        }
    }

    const removeWatchlistauction = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'removeAuctionWatchList', formData, '', 'auction'),
            ])
            resp.commonResponse(res.data, 'auctionwatchlist')
        } catch (err) {
            resp.commonErrorResponse('auctionwatchlist')
        }
    }

    const userPanVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userPanVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }

    const userDrivingLicenseVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userDrivingLicenseVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }
    const userVoterIdVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userVoterIdVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }
    const userUdyogAadharVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userUdyogAadharVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }

    const userGstVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userGstVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])

            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }

    const userAadharVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userAadharVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])

            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }

    const userPassportVerification = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'userPassportVerification',
                    formData,
                    '',
                    'third_party/userKycVerification',
                ),
            ])

            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse('error')
        }
    }

    const getAllDashboardwatchlist = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'auctionWatchList', formData, '', 'auction'),
            ])
            let fromValue = from || 'displaywatchlist'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_DASHBOARD,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                        from: fromValue,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const updateAuctionTerms = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'updateAuctionTerms'
            const [res] = await Promise.all([
                apiCall('post', 'updateAuctionTerms', formData, '', 'auction'),
            ])
            console.log(res, 'reff')

            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllDashboardAuctions = async (formData, from) => {
        try {
            const [res] = await Promise.all([apiCall('post', 'myBids', formData, '', 'auction')])
            const fromValue = from || 'dashboard'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_DASHBOARD,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData.sorts,
                        from: fromValue,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }
    const getEmdListForAuction = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getemdlist', formData, '', 'custom/front/auction', false, true),
            ])
            const from = fromVariable ? fromVariable : 'Auctions'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_EMD_LIST,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],

                        from: fromVariable,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const cashFreeEmdPayment = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'generate_link', formData, '', 'paymentThird/cashfree'),
            ])
            resp.commonResponse(res.data, 'generate_link_cashfree')
        } catch (err) {
            resp.commonErrorResponse('generate_link_cashfree')
        }
    }

    const cashFreeResponseCheck = async (formData) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'response_check', formData, '', 'paymentThird/cashfree'),
            ])
            resp.commonResponse(res.data, 'cashfreeResponse')
        } catch (err) {
            resp.commonErrorResponse('cashfreeResponse')
        }
    }

    const payCartsOfflineEmd = async (formData, fromValue) => {
        const from = fromValue ? fromValue : 'payCartsOfflineEmd'
        try {
            const [res] = await Promise.all([
                apiCall('post', 'payCartsOfflineEmd', formData, '', 'offline'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const newsLetterSubscribe = async (formData, fromValue) => {
        const from = fromValue ? fromValue : 'newsLetterSubscribe'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'newsLetterSubscribe',
                    formData,
                    '',
                    'custom/front/subscribe',
                    false,
                    true,
                ),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            resp.commonErrorResponse(from)
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <AuctionContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                search_allauctions: state.search_allauctions,
                search_all_pastauction: state.search_all_pastauction,
                responseStatus: state.responseStatus,
                search_alldashboardauctions: state.search_alldashboardauctions,
                all_user_agreement: state.all_user_agreement,
                clearResponse,
                getAllAuctionProducts,
                getAllDashboardAuctions,
                auctionAccessRequest,
                updateAuctionTerms,
                newsLetterSubscribe,
                addWatchlistauction,
                getAllDashboardwatchlist,
                cashFreeResponseCheck,
                userProofDetails,
                userAgreement,
                cashFreeEmdPayment,
                userPanVerification,
                userVoterIdVerification,
                userDrivingLicenseVerification,
                userUdyogAadharVerification,
                userGstVerification,
                userBankDetails,
                userTaxDetails,
                userBrandLocations,
                removeWatchlistauction,
                auction_emd_list: state.auction_emd_list,
                getEmdListForAuction,
                payCartsOfflineEmd,
                userAadharVerification,
                userPassportVerification,
                getUserAgreement,
            }}
        >
            {props.children}
        </AuctionContext.Provider>
    )
}

export default AuctionState
